export enum FilterManagerFilterType {
  options = "options",
  number = "number",
}
